export default (path, name, value) => {
  const url = new URL(path);
  const searchParams = url.searchParams;
  searchParams.set(name, value)

  return url.href
}
